import {
  Home,
  Group,
  AdminPanelSettings,
  Business,
  LocalActivity,
  CoPresent,
  Folder,
  UploadFile,
  Factory,
  AccountBalance,
  Checklist,
  Settings,
  AccountTree,
  AttachMoney,
  People,
  DeleteSweep,
  Loyalty,
  LaptopChromebook,
  WaterDrop,
  CarRental,
  QueryStats,
  Speed,
  CalendarViewWeek,
  FileDownload,
} from "@mui/icons-material";
import { _ROUTER_DOM_URL } from "../../utils/_routes_constants";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PreviewIcon from "@mui/icons-material/Preview";
import { _ROLES_BACK } from "../../utils/constants"; // ajout import rôles

export const _MENU = [
  {
    title: "Dashboard",
    icon: <Home />,
    path: _ROUTER_DOM_URL.DASHBOARD_GENERAL,
    roles: [
      _ROLES_BACK._ROLE_USER,
      _ROLES_BACK._ROLE_ADMIN,
      _ROLES_BACK._ROLE_CTRL,
      _ROLES_BACK._ROLE_PAYROLL,
      _ROLES_BACK._ROLE_SALES,
      _ROLES_BACK._ROLE_HR,
      _ROLES_BACK._ROLE_IT,
      _ROLES_BACK._ROLE_ENGINEERING,
      _ROLES_BACK._ROLE_FLEET_OP,
      _ROLES_BACK._ROLE_HEALTH_SAFETY,
      _ROLES_BACK._ROLE_LRU,
      _ROLES_BACK._ROLE_LRL,
      _ROLES_BACK._ROLE_DEPRECIATION,
    ],
  },
  {
    title: "Parameters",
    icon: <Settings />,
    roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
    submenu: [
      {
        title: "Account Parameters",
        id: 1,
        icon: <AccountTree />,
        path: _ROUTER_DOM_URL.ACCOUNT_PARAMETERS,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
    ],
  },
  {
    title: "Admin",
    indexParent: 2,
    icon: <AdminPanelSettings />,
    roles: [_ROLES_BACK._ROLE_ADMIN],
    submenu: [
      {
        title: "Users",
        id: 2,
        icon: <Group />,
        path: _ROUTER_DOM_URL.USERS,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
      {
        title: "Companies",
        id: 3,
        icon: <Business />,
        path: _ROUTER_DOM_URL.COMPANIES,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
      {
        title: "Activities",
        id: 4,
        icon: <LocalActivity />,
        path: _ROUTER_DOM_URL.ACTIVITES,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
      {
        title: "Sites",
        id: 5,
        icon: <CoPresent />,
        path: _ROUTER_DOM_URL.SITES,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
      {
        title: "Sources",
        id: 6,
        icon: <Factory />,
        path: _ROUTER_DOM_URL.SOURCES,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
      {
        title: "Volumes Filaire",
        id: 6,
        icon: <LocalActivity />,
        path: _ROUTER_DOM_URL.VOLUME_FILAIRE,
        roles: [_ROLES_BACK._ROLE_ADMIN],
      },
    ],
  },
  {
    title: "Real",
    indexParent: 3,
    icon: <Folder />,
    roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
    submenu: [
      {
        title: "Data",
        icon: <QueryStats />,
        path: _ROUTER_DOM_URL.REAL_DATA,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
      {
        title: "Import",
        id: 2,
        icon: <UploadFile />,
        path: _ROUTER_DOM_URL.REAL_IMPORT,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
    ],
  },
  {
    title: "Indicators",
    indexParent: 5,
    icon: <Speed />,
    roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
    submenu: [
      {
        title: "Templates",
        id: 1,
        icon: <CalendarViewWeek />,
        path: _ROUTER_DOM_URL.INDICATORS_TEMPLATES,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
      {
        title: "Template View",
        id: 2,
        icon: <PreviewIcon />,
        path: _ROUTER_DOM_URL.INDICATORS_TEMPLATE_VIEW,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
    ],
  },
  {
    title: "Budget",
    indexParent: 4,
    icon: <AccountBalance />,
    roles: [
      _ROLES_BACK._ROLE_ADMIN,
      _ROLES_BACK._ROLE_CTRL,
      _ROLES_BACK._ROLE_PAYROLL,
      _ROLES_BACK._ROLE_SALES,
      _ROLES_BACK._ROLE_HR,
      _ROLES_BACK._ROLE_IT,
      _ROLES_BACK._ROLE_ENGINEERING,
      _ROLES_BACK._ROLE_FLEET_OP,
      _ROLES_BACK._ROLE_HEALTH_SAFETY,
      _ROLES_BACK._ROLE_LRU,
      _ROLES_BACK._ROLE_LRL,
      _ROLES_BACK._ROLE_DEPRECIATION,
    ],
    submenu: [
      {
        title: "Parameters",
        id: 1,
        icon: <Checklist />,
        path: _ROUTER_DOM_URL.BUDGET_PARAMETERS,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
      {
        title: "Export Budget",
        id: 1,
        icon: <FileDownload />,
        path: _ROUTER_DOM_URL.EXPORT_BUDGET,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
      {
        title: "Input Rate Increase",
        id: 2,
        icon: <CallMissedOutgoingIcon />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_RATE_INCREASE,
        roles: [_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL],
      },
      {
        title: "Input Payroll",
        id: 3,
        icon: <AttachMoney />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_PAYROLL,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_PAYROLL,
        ],
      },
      {
        title: "Input HR",
        id: 4,
        icon: <People />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_HR,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_HR,
        ],
      },
      {
        title: "Input Plums Split Source",
        id: 5,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_PLUMS_SPLIT_SOURCE,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_ENGINEERING,
        ],
      },
      {
        title: "Input Waste Rate",
        id: 6,
        icon: <DeleteSweep />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_WASTE_RATE,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_HEALTH_SAFETY,
        ],
      },
      {
        title: "Input Sales Volume Filaire",
        id: 7,
        icon: <Loyalty />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_SF,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_SALES,
        ],
      },
      {
        title: "Input IT",
        id: 8,
        icon: <LaptopChromebook />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_ITS,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_IT,
        ],
      },
      {
        title: "Input Fleet Optimisation",
        id: 9,
        icon: <WaterDrop />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_FLEET_OPTIMISATION,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_FLEET_OP,
        ],
      },
      {
        title: "Input Depreciation",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_DEPRECIATION,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_DEPRECIATION,
        ],
      },
      {
        title: "Input Sales AGG",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_SALES_AGG,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_LRU,
        ],
      },
      {
        title: "Input Hire of Equipment",
        icon: <CarRental />,
        path: _ROUTER_DOM_URL.BUDGET_INPUT_HIRE_EQUIPMENT,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_ENGINEERING,
        ],
      },
      {
        title: "Input Sales Depot",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_SALES_DEPOT,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_LRL,
        ],
      },
      {
        title: "Input Sales Block",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_SALES_BLOCK,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_LRL,
        ],
      },
      {
        title: "Input Quarrying Excavator",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_QUARRIYING_EXCAVATOR,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_ENGINEERING,
        ],
      },
      {
        title: "Input Turnover LRL",
        id: 1,
        icon: <EditNoteIcon />,
        path: _ROUTER_DOM_URL.INPUT_TURNOVER_LRL,
        roles: [
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          _ROLES_BACK._ROLE_LRL,
        ],
      },
    ],
  },
];
